export default "__VITE_ASSET__5e3f4a0b__"